import { styled, theme } from "@theme/stitches.config"
import { Container } from "@components/styles"
import { Link } from "gatsby"

export const FooterWrapper = styled("footer", {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    background: "linear-gradient(224.04deg, rgba(255, 0, 0, 0.8) 24.34%, #B9271C 50.31%)",
    minHeight: 802,
    "@mdDown": {
        minHeight: 0
    }
})

export const InnerWrapper = styled(Container, {
    pt: 233,
    pb: 46,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    "@mdDown": {
        pt: 100
    }
})

export const ImageWrapper = styled("div", {
    position: "absolute",
    overflow: "hidden",
    bottom: -10,
    right: 0,
    "@mdDown": {
        display: "none"
    }
})

export const LinkWrapper = styled("div", {
    mt: "auto",
    display: "flex",
    alignItems: "center",
    mx: -8,
    zIndex: 1,
    "@mdDown": {
        mt: 60,
        flexDirection: "column",
        alignItems: "unset"
    }
})

export const StyledLink = styled(Link, {
    textTransform: "uppercase",
    px: 8,
    fontSize: theme.fontSizes.desktopH6,
    color: theme.colors.white,
    lineHeight: 1.2,
    fontFamily: theme.fonts.heading,
    "@mdDown": {
        fontSize: theme.fontSizes.mobileH4,
        ml: 0,
        "&:not(:first-child)": {
            mt: 20
        }
    }
})

export const StyledSpan = styled("span", {
    textTransform: "uppercase",
    px: 8,
    fontSize: theme.fontSizes.desktopH6,
    color: theme.colors.white,
    lineHeight: 1.2,
    fontFamily: theme.fonts.heading,
    "@mdDown": {
        fontSize: theme.fontSizes.mobileH4,
        ml: 0,
        "&:not(:first-child)": {
            mt: 20
        }
    }
})

export const LogoWrapper = styled("div", {
    ml: "auto",
    "@mdDown": {
        ml: 0,
        mt: 40
    }
})
